/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes,extraRequire}
 * tslint:disable
 */
var styles = [".pad0[_ngcontent-%COMP%]{padding:0}.brdrFocus[_ngcontent-%COMP%]:active, .brdrFocus[_ngcontent-%COMP%]:focus, .brdrFocus[_ngcontent-%COMP%]:focus-visible, .brdrFocus[_ngcontent-%COMP%]:hover{border:1px solid #bcc2c9!important;outline:none}"];
export { styles as styles };

